<template>
  <div class="user-delete-block">
    <h3 class="user-delete-block__title">{{ $t('view.flow.block.userDelete.userDelete') }}</h3>
    <div class="user-delete-block__wrapper">
      <p>{{ $t('view.flow.block.userDelete.userDeleteText') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-delete-block {
  @include flowElementShadow();
  width: 30%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;
}
</style>
